import React, { useEffect } from 'react';
import { PIXEL_ID, trackPixelEvent } from './lib/constants';
import { Hero } from './components/Hero';
import { BeforeAfter } from './components/BeforeAfter';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { About } from './components/About';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { FloatingCta } from './components/FloatingCta';
import { SalesPopup } from './components/SalesPopup';
export function App() {
  useEffect(() => {
    // Do not inject Meta's remote JavaScript into the app: browser privacy tools
    // and embedded previews can turn that third-party failure into “Script error.”
    // This beacon tracks the same PageView without making rendering dependent on it.
    trackPixelEvent('PageView');
  }, []);
  return <div className="w-full bg-cream font-sans text-plum" data-id="element-0" data-mp="3mkhlps1j704z">
      <noscript data-id="element-1" data-mp="3rc9em985thya">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="3rcj2nr9n9f1c" />
      </noscript>

      <main className="w-full" data-id="element-3" data-mp="2zm4y4lnitf2c">
        <Hero data-id="element-4" data-mp="2zmwguvw0rib7" />
        <BeforeAfter data-id="element-5" data-mp="2zng14j956ise" />
        <Recognize data-id="element-6" data-mp="33mf1rrnubte1" />
        <WhatsInside data-id="element-7" data-mp="33lx0ggmbmoz9" />
        <Bonuses data-id="element-8" data-mp="33n6zb810016y" />
        <Offer data-id="element-9" data-mp="33orhrza1ftog" />
        <Guarantee data-id="element-10" data-mp="33oi0d0326uud" />
        <Testimonials data-id="element-11" data-mp="38l8idsyfc0if" />
        <About data-id="element-12" data-mp="38kqafz2efxuo" />
        <Faq data-id="element-13" data-mp="38k6v8q44vnkc" />
        <FinalCta data-id="element-14" data-mp="38nuorp9kw9z2" />
      </main>

      <Footer data-id="element-15" data-mp="3dkl58dpap7l0" />

      <FloatingCta data-id="element-16" data-mp="3dl4lzr37lpxg" />
      <SalesPopup data-id="element-17" data-mp="3dlnru9fl4nv4" />
    </div>;
}